import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    timeout: 60000,
});

// Silence expected 401s on /auth/me when the visitor is anonymous (landing page).
// Real auth flows handle their own errors, so this is purely a console-hygiene filter.
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const url = err?.config?.url || "";
        const status = err?.response?.status;
        if (status === 401 && url.includes("/auth/me")) {
            return Promise.reject({ ...err, silenced: true });
        }
        return Promise.reject(err);
    },
);

// Official Gantari Edu WhatsApp business number
export const WA_NUMBER = "6285195555610";

export const WA_MESSAGES = {
    default: "Halo Gantari Edu, saya ingin konsultasi awal tentang rencana kuliah ke luar negeri.",
    roi: "Halo Gantari Edu, saya ingin diskusi hasil simulasi biaya dan ROI kuliah luar negeri.",
    document: "Halo Gantari Edu, saya ingin cek kesiapan dokumen untuk kuliah luar negeri.",
    assessment: "Halo Gantari Edu, saya baru selesai assessment dan ingin konsultasi rekomendasi kampusnya.",
    article: "Halo Gantari Edu, saya baru baca artikel di website dan ingin konsultasi lanjutan.",
};

export const waUrl = (msg = WA_MESSAGES.default) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
